import { IController, IComponentOptions } from "angular";

export class OkrStatusModalCtrl implements IController {}

export const OkrStatusModalComponent: IComponentOptions = {
  controller: OkrStatusModalCtrl,
  transclude: true,
};
